module.exports = __webpack_public_path__ + "images/do-not-disturb.svg";